export default {
  bovespa: 'Acción en la Bovespa',
  volume: 'Volumen',
  price: 'Precio',
  mentions: 'Menciones',
};
